/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".background[_ngcontent-%COMP%]{width:256px;min-height:280px}.background__section[_ngcontent-%COMP%]{display:flex;flex-direction:column}.background__swatches[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap}"];
export { styles as styles };
